class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector("#predictive-search");
    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event);
        var input_length = this.input.value.length;
        if (input_length > 0) {
          document
            .querySelectorAll(".search-Button")
            .forEach(function (SeachButtons) {
              SeachButtons.disabled = false;
            });
        } else {
          document
            .querySelectorAll(".search-Button")
            .forEach(function (SeachButtons) {
              SeachButtons.disabled = true;
            });
        }
      }, 300).bind(this)
    );
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(
      `/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
        if (typeof quickAddButton == "function") {
          quickAddButton();
        }
        if (document.getElementById("SearchValue")) {
          document.getElementById("SearchValue").value = searchTerm;
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }
  open() {
    this.predictiveSearchResults
      .closest(".search_wrapper")
      .classList.add("active");
    this.predictiveSearchResults.closest(".search_wrapper").style.height =
      this.predictiveSearchResults.closest(".search_wrapper-inr").offsetHeight +
      "px";
  }
  close() {
    this.predictiveSearchResults
      .closest(".search_wrapper")
      .classList.remove("active");
    this.predictiveSearchResults.closest(".search_wrapper").style.height =
      this.predictiveSearchResults.closest(".search_wrapper-inr").offsetHeight +
      "px";
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define("predictive-search", PredictiveSearch);
document.querySelector(".overlay-box").addEventListener("click", function (e) {
  document.querySelector("body").classList.remove("open-menu");
});
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelectorAll("video"))
    document.querySelectorAll("video").forEach((video) => {
      video.muted = true;
      // video.volume = 0;
    });
});
function quickAddButton() {
  if (document.querySelectorAll(".variant-grid")) {
    document.querySelectorAll(".variant-grid").forEach(function (sizeList) {
      sizeList.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        sizeList.classList.add("addingCart");
        let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest(".snippet-product-grid");
        let error_grid = error_grid_outer.querySelector(".grid-error");
        let formData = {
          items: [
            {
              id: variant_id,
              quantity: 1,
            },
          ],
        };
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((data) => {
            cartNotification(data.items[0].id);
            if (data.status == 422) {
              error_grid.innerHTML = data.description;
              setTimeout(function (e) {
                error_grid.innerHTML = "";
              }, 2000);
            } else {
              if (document.location.href.indexOf("/cart") > -1) {
                window.location.href = "/cart";
              } else {
                if (typeof load_cart == "function") {
                  load_cart();
                } else {
                  window.location.href = "/cart";
                }
              }
              const url = "/cart.js";
              fetch(url)
                .then((resp) => resp.json())
                .then(function (data) {
                  var cart_count = data.item_count;
                  if (cart_count > 0) {
                    document.querySelector(".cart-count").innerHTML =
                      cart_count;
                  } else {
                    document.querySelector(".cart-count").innerHTML = "";
                  }
                })
                .catch(function (error) {
                  console.log(error);
                });
            }
            setTimeout(() => {
              sizeList.classList.remove("addingCart");
              sizeList.classList.add("addedCart");
              setTimeout(function (e) {
                sizeList.classList.remove("addedCart");
              }, 2000);
            }, 1300);
          })
          .catch((error) => {
            console.error(error);
          });
      });
    });
  }
  document.querySelectorAll(".grid-select-btn").forEach((gridSelect) => {
    gridSelect.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      let activeSize = true;
      gridSelect
        .closest(".grid-btm")
        .querySelectorAll(".grid-size-variants li")
        .forEach((size) => {
          if (size.classList.contains("active")) activeSize = false;
        });
      if (activeSize) {
        let height =
          gridSelect.closest(".grid-btm").querySelector(".size_variant")
            .offsetHeight + 10;
        gridSelect.closest(".snippet-product-grid").classList.add("selectSize");
        gridSelect
          .closest(".snippet-product-grid")
          .querySelector(".grid-top").style.top = "-" + height + "px";
      }
    });
  });
  if (document.querySelector(".snippet-product-grid"))
    document
      .querySelectorAll(".snippet-product-grid")
      .forEach(function (prodGrid) {
        prodGrid.addEventListener("mouseleave", (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          prodGrid.classList.remove("selectSize");
          prodGrid.querySelector(".grid-top").style.top = "";
        });
      });
  document.querySelectorAll(".snippet-product-grid").forEach((allGrid) => {
    allGrid
      .querySelectorAll(".grid-size-variants li")
      .forEach((gridVariant) => {
        gridVariant.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          allGrid
            .querySelectorAll(".grid-size-variants li")
            .forEach((gridVariant) => {
              gridVariant.classList.remove("active");
            });
          gridVariant.classList.add("active");
          gridVariant
            .closest(".grid-btm")
            .querySelector(".grid-variant-btns .grid-add-btn")
            .setAttribute("data-id", gridVariant.getAttribute("data-id"));
          gridVariant
            .closest(".grid-btm")
            .querySelector(".grid-variant-btns")
            .classList.add("active_added_btn");
          var grid_length = gridVariant
            .closest(".snippet-product-grid")
            .querySelectorAll(".grid-badge span").length;
          var selected_value = gridVariant.getAttribute("data-preorder");
          // console.log("selected_value", selected_value);
          // console.log("grid_length", grid_length);
          if (!grid_length && selected_value == "true") {
            var grid_length_text = gridVariant
              .closest(".grid-size-variants")
              .getAttribute("data-preorder-button-text");
            gridVariant
              .closest(".snippet-product-grid")
              .querySelector(".grid-badge")
              .insertAdjacentHTML(
                "beforeend",
                '<span class="preorder-badge">' + grid_length_text + "</span>"
              );
            gridVariant
              .closest(".snippet-product-grid")
              .querySelector(".p-add-cart-btn").innerHTML = "Pre-order";
            gridVariant
              .closest(".snippet-product-grid")
              .querySelector(".variant-grid")
              .classList.add("button-pink");
          }
          if (selected_value == "false") {
            gridVariant
              .closest(".snippet-product-grid")
              .querySelector(".grid-badge .preorder-badge")
              .remove();
            gridVariant
              .closest(".snippet-product-grid")
              .querySelector(".variant-grid")
              .classList.remove("button-pink");
            gridVariant
              .closest(".snippet-product-grid")
              .querySelector(".p-add-cart-btn").innerHTML = "Add to cart";
          }
        });
      });
  });
}
quickAddButton();
if (document.querySelector(".nav-arrow")) {
  document.querySelectorAll(".nav-arrow").forEach(function (navArrow) {
    navArrow.addEventListener("click", function (e) {
      navArrow.closest("li").classList.toggle("active");
    });
  });
}
document.onkeydown = function (evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = evt.key === "Escape" || evt.key === "Esc";
  } else {
    isEscape = evt.keyCode === 27;
  }
  if (isEscape) {
    document
      .querySelector("body")
      .classList.remove(
        "open-filter",
        "open-sort",
        "open-drawer",
        "open-menu",
        "open-search"
      );
  }
};
var counttime = 0;
function cartNotification(cartId) {
  fetch(window.Shopify.routes.root + "?section_id=cart-notification")
    .then((response) => response.text())
    .then((responseText) => {
      const cnID = "cart-notification";
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const destination = document.querySelector(".cart_popup");
      const source = html.getElementById(cnID);
      if (source && destination) destination.innerHTML = source.innerHTML;
      let lastItem = document.querySelector(
        ".ch_items .cn_" + cartId
      ).innerHTML;
      if (lastItem) document.querySelector(".ch_items").innerHTML = lastItem;
      if (document.querySelector(".cart-notification")) {
        setTimeout(() => {
          document.querySelector(".cart_popup").classList.add("active");
        }, 1000);
      }
      counttime = 0;
      const myInterval = setInterval(timer, 1000);
      function timer() {
        counttime++;
        if (counttime > 5) {
          document.querySelector(".cart_popup").classList.remove("active");
          setTimeout(() => {
            document.querySelector(".cart_popup").innerHTML = "";
          }, 3000);
          myStop();
        }
      }
      function myStop() {
        clearInterval(myInterval);
      }
      document.body.addEventListener("click", function (e) {
        var popup = document.querySelector(".cart_popup");
        if (!popup.contains(event.target)) {
          popup.innerHTML = "";
        }
      });
    });
}

// document.addEventListener('DOMContentLoaded', () => {
//   const cursor = document.createElement('div');
//   cursor.classList.add('custom-cursor', 'hidden');
//   document.body.appendChild(cursor);
//   const typingSpan = document.createElement('span');
//   typingSpan.classList.add('typing-animation');
//   cursor.appendChild(typingSpan);
//   let typingInterval;
//   const typeText = (text) => {
//     typingSpan.textContent = '';
//     let index = 0;
//     typingInterval = setInterval(() => {
//       typingSpan.textContent += text[index];
//       index++;
//       if(index === text.length){
//         clearInterval(typingInterval);
//         setTimeout(() => {
//           typingSpan.classList.add('completed');
//         },100);
//       }
//     }, 30);
//   };
//   document.addEventListener('mousemove', (e) => {
//     cursor.style.left = `${e.clientX + 10}px`;
//     cursor.style.top = `${e.clientY + 10}px`;
//     if(!e.target.closest('[data-cursor-text]')){
//       cursor.classList.add('hidden');
//     } else {
//       cursor.classList.remove('hidden');
//     }
//   });
//   document.addEventListener('mouseleave', () => {
//     cursor.classList.add('hidden');
//   });
//   document.addEventListener('mouseenter', () => {
//     cursor.classList.remove('hidden');
//   });

//   const handleMouseEnter = (event) => {
//     const element = event.currentTarget;
//     const text = element.getAttribute('data-cursor-text');
//     clearInterval(typingInterval);
//     typingSpan.classList.remove('completed');
//     typeText(text);
//   };
//   const elementsWithCustomCursor = document.querySelectorAll('[data-cursor-text]');
//   elementsWithCustomCursor.forEach(element => {
//     element.addEventListener('mouseenter', handleMouseEnter);
//   });
// });

document.addEventListener("DOMContentLoaded", () => {
  const cursor = document.createElement("div");
  cursor.classList.add("custom-cursor", "hidden");
  document.body.appendChild(cursor);
  const typingSpan = document.createElement("span");
  typingSpan.classList.add("typing-animation");
  cursor.appendChild(typingSpan);
  let typingInterval;
  let reverseTypingInterval;

  // Function to handle forward typing animation
  const typeText = (text) => {
    typingSpan.textContent = "";
    let index = 0;
    typingInterval = setInterval(() => {
      typingSpan.textContent += text[index];
      index++;
      if (index === text.length) {
        clearInterval(typingInterval);
        setTimeout(() => {
          typingSpan.classList.add("completed");
        }, 100);
      }
    }, 30);
  };

  // Function to handle reverse typing animation
  const reverseTypeText = () => {
    let text = typingSpan.textContent;
    let index = text.length - 1;
    reverseTypingInterval = setInterval(() => {
      typingSpan.textContent = text.slice(0, index);
      index--;
      if (index < 0) {
        clearInterval(reverseTypingInterval);
      }
    }, 30);
  };

  // Mouse movement to update cursor position and visibility
  document.addEventListener("mousemove", (e) => {
    cursor.style.left = `${e.clientX + 10}px`;
    cursor.style.top = `${e.clientY + 10}px`;
    if (!e.target.closest("[data-cursor-text]")) {
      cursor.classList.add("hidden");
    } else {
      cursor.classList.remove("hidden");
    }
  });

  // Hide cursor when mouse leaves the document
  document.addEventListener("mouseleave", () => {
    cursor.classList.add("hidden");
  });

  document.addEventListener("mouseenter", () => {
    cursor.classList.remove("hidden");
  });

  // Handle text typing when the mouse enters the element
  const handleMouseEnter = (event) => {
    const element = event.currentTarget;
    const text = element.getAttribute("data-cursor-text");
    clearInterval(typingInterval);
    clearInterval(reverseTypingInterval);
    typingSpan.classList.remove("completed");
    typeText(text);
  };

  // Handle reverse typing when the mouse leaves the element
  const handleMouseLeave = () => {
    clearInterval(typingInterval);
    clearInterval(reverseTypingInterval);
    reverseTypeText();
  };

  // Attach event listeners to elements with custom cursor
  const elementsWithCustomCursor =
    document.querySelectorAll("[data-cursor-text]");
  elementsWithCustomCursor.forEach((element) => {
    element.addEventListener("mouseenter", handleMouseEnter);
    element.addEventListener("mouseleave", handleMouseLeave);
  });
});

document.addEventListener("DOMContentLoaded", function() {
    if (window.location.pathname.startsWith("/nl/account/activate/")) {
        const newPath = window.location.pathname.replace("/nl", "");
        window.location.href = newPath + window.location.search;
    }
});

document.addEventListener('DOMContentLoaded', function() {
  // Function to update the checkout button prices
  const updateCheckoutPrices = () => {
    const subtotalElement = document.querySelector('.cart-sidebar form:not(.b2b-customer-avail) .docapp-cart-with-coupon-summary--summary .docapp-cart-item.docapp-est-total.docapp-perm .docapp-right span.money');
    if (subtotalElement) {
      const newSubtotal = subtotalElement.getAttribute('data-amount');
      const currency = subtotalElement.textContent.trim();
      if (newSubtotal && currency) {
        const checkoutButtonPrices = document.querySelectorAll('.cart-total-price');
        if (checkoutButtonPrices.length > 0) {
          checkoutButtonPrices.forEach(checkoutButtonPrice => {
            checkoutButtonPrice.textContent = currency;
          });
        }
      }
    }
  };

// Debounce function to limit the rate at which a function can fire
function debounce(func, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

// Options for the observer (which mutations to observe)
const config = { attributes: true, childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = debounce(function(mutationsList, observer) {
  for (let mutation of mutationsList) {
    if (mutation.type === 'attributes' || mutation.type === 'childList') {
      updateCheckoutPrices();
    }
  }
}, 200); // Adjust the debounce wait time as needed

// Create an observer instance linked to the callback function for the cart drawer
const cartDrawerObserver = new MutationObserver(callback);
const cartDrawerNode = document.querySelector('.cart-sidebar');
if (cartDrawerNode) {
  cartDrawerObserver.observe(cartDrawerNode, config);
}

// Create an observer instance linked to the callback function for the cart page
const cartPageObserver = new MutationObserver(callback);
const cartPageNode = document.querySelector('.cart-summary');
if (cartPageNode) {
  cartPageObserver.observe(cartPageNode, config);
}
});